(function () {
    'use strict';

    var SEAT_PATTERN = /^\/seats\/([A-Z0-9]+)\/?$/i;
    var LARAVEL_API = 'https://pollingreport.uk/api/v1/candidates';

    function getSeatCode() {
        var m = window.location.pathname.match(SEAT_PATTERN);
        return m ? m[1].toUpperCase() : null;
    }

    function onCandidatesTurnstileSuccess(token) {
        var tokenInput = document.getElementById('cw-turnstile-token');
        var form = document.getElementById('candidates-wanted-form');
        if (tokenInput) tokenInput.value = token;
        if (form) form.style.display = '';
    }

    // Expose callback globally for Turnstile
    window.onCandidatesTurnstileSuccess = onCandidatesTurnstileSuccess;

    function setStatus(el, msg, isError) {
        el.textContent = msg;
        el.className = 'ukpr-candidates-wanted-status ' + (isError ? 'is-error' : 'is-success');
    }

    function initWidget() {
        var seatCode = getSeatCode();
        var widget = document.getElementById('candidates-wanted-widget');
        if (!widget) return;

        if (!seatCode) {
            // Not on an individual seat page — leave hidden
            return;
        }

        // Show widget
        widget.style.display = '';

        // Populate hidden seat code field
        var codeInput = document.getElementById('cw-constituency-code');
        if (codeInput) codeInput.value = seatCode;

        // Wire up form submission
        var form = document.getElementById('candidates-wanted-form');
        if (!form) return;

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var status = form.querySelector('.ukpr-candidates-wanted-status');
            var btn = form.querySelector('.ukpr-candidates-wanted-submit');

            var name = document.getElementById('cw-name');
            var party = document.getElementById('cw-party');
            var token = document.getElementById('cw-turnstile-token');

            if (!name || !name.value.trim() || name.value.trim().length < 3) {
                setStatus(status, 'Please enter the candidate\'s full name (at least 3 characters).', true);
                return;
            }
            if (!party || !party.value) {
                setStatus(status, 'Please select a party.', true);
                return;
            }
            if (!token || !token.value) {
                setStatus(status, 'Verification incomplete. Please try again.', true);
                return;
            }

            btn.disabled = true;
            btn.textContent = 'Submitting…';
            setStatus(status, '', false);

            var payload = {
                full_name: name.value.trim(),
                party_id: party.value,
                constituency_code: codeInput ? codeInput.value : '',
                'cf-turnstile-response': token.value
            };

            fetch(LARAVEL_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload)
            }).then(function (res) {
                if (res.ok) {
                    form.style.display = 'none';
                    setStatus(status, 'Thank you! We\'ll review and add them shortly.', false);
                    status.style.display = 'block';
                } else {
                    return res.json().then(function (data) {
                        var msg = (data && data.message) ? data.message : 'Submission failed. Please try again.';
                        setStatus(status, msg, true);
                        btn.disabled = false;
                        btn.textContent = 'Submit';
                        // Reset Turnstile token so user can retry
                        if (window.turnstile) window.turnstile.reset();
                        if (token) token.value = '';
                        form.style.display = 'none';
                    });
                }
            }).catch(function () {
                setStatus(status, 'Network error. Please check your connection and try again.', true);
                btn.disabled = false;
                btn.textContent = 'Submit';
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWidget);
    } else {
        initWidget();
    }
}());
